module.exports = __webpack_public_path__ + "img/myCollect-select.884626cc.svg";